import {Component, Input, OnChanges, OnInit} from '@angular/core';
import {CommonModule} from '@angular/common';


@Component({
  selector: 'in-breadcrumbs',
  templateUrl: './breadcrumbs.component.html',
  styleUrls: ['./breadcrumbs.component.scss'],
  standalone: true,
  imports: [CommonModule]
})
export class BreadCrumbsComponent implements OnInit, OnChanges {


  @Input() path = [];


  crumbs = [];

  ngOnInit() {
    this.crumbs = [];
    this.path.forEach(val => {
      this.crumbs.push(val);
      this.crumbs.push('•');
    });
    this.crumbs.pop();
  }


  ngOnChanges(changes) {
    this.crumbs = [];
    this.path.forEach(val => {
      this.crumbs.push(val);
      this.crumbs.push('•');
    });
    this.crumbs.pop();
  }
}
